import React, { useState, useEffect } from "react";

import UseListComponent from "./useListComponent";
import "./usersList.css";
import { getUsers } from "../../Data/Users";

function UsersList() {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      const allUsers = getUsers();
      setUsers(
        (await allUsers).docs.map((doc) => {
          return {
            data: doc.data(),
            id: doc.id,
          };
        })
      );
    };
    return fetchUsers();
  }, []);

  return (
    <div className="users_list">
      <h2>
        <center>USERS LIST</center>
      </h2>
      <hr />
      <br />
      <br />
      {users.map((users) => {
        return <UseListComponent users={users} key={users.id} />;
      })}
    </div>
  );
}

export default UsersList;
